import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import StatisticsCard from './StatisticsCard';
import { actionStatisticsService, ActionStatistics } from '../../services/ActionStatisticsService';

const PlannedActionsCard: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [data, setData] = useState<ActionStatistics | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const result = await actionStatisticsService.getPlannedActions();
                setData(result);
            } catch (error) {
                console.error('Error fetching planned actions:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleClick = () => {
        navigate('/tw/plano-de-acao?situacao=Planejada');
    };

    return (
        <StatisticsCard
            title="Total de Ações"
            value={data?.count ?? 0}
            loading={loading}
            color="#FFEB3B"
            icon={<AssignmentOutlinedIcon fontSize="large" />}
            subtitle="Todas as ações"
            onClick={handleClick}
        />
    );
};

export default PlannedActionsCard;
